"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  update: function(carrierId, carrier, success) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/carriers/" + carrierId,
      type: "put",
      data: JSON.stringify({ carrier }),
      contentType: "application/json",
      success: function(data) {
        DataStoreService.updateStores(data);
        if (success) {
          success();
        }
      }
    }));
  },
  fetchUpdate: function(carrierId) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/carriers/" + carrierId,
      cache: false,
      type: "get"
    })).then(DataStoreService.responseHandler, _.identity);
  }
};
